import { render } from "./CurriculumView.vue?vue&type=template&id=af50bb46&scoped=true"
import script from "./CurriculumView.vue?vue&type=script&lang=js"
export * from "./CurriculumView.vue?vue&type=script&lang=js"

import "./CurriculumView.vue?vue&type=style&index=0&id=af50bb46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af50bb46"]])

export default __exports__